import React, { useMemo } from 'react';
import './BtnWhatsapp.css';
import whatsappIcon from '../../images/wpp.png';
import { useData } from '../DataContext';

export default function BtnWhatsapp() {
    const { contacto } = useData();

    const telefono = useMemo(() => {
        if (Array.isArray(contacto)) {
            return [...contacto].reverse()[0]?.telefono;
        }
        return contacto?.telefono;
    }, [contacto]);

    const handleClick = () => {
        if (telefono) {
            window.open(`https://wa.me/${telefono}`, '_blank');
        }
    };

    return (
        <div className='containWpp'>
            <button className='btnWhatsapp' onClick={handleClick}>
                <img src={whatsappIcon} alt="whatsappIcon" />
            </button>
        </div>
    );
}
